(function (ng) {
    

    const WindowCtrl = function () {
        const ctrl = this;
    };

    angular.module('windowExt').controller('WindowCtrl', WindowCtrl);

    WindowCtrl.$inject = [];
})(angular);
